<template>
    <div v-if="simpleHotlineContractOption" class="tab-pane slide-left active">
        <div class="title">
            <h3>Contacts pour permanence téléphonique</h3>
            <button class="btn btn-complete"
                    v-show="!isFormDisplayed && !contract.terminated"
                    @click="getHotlineContactCreationForm">Ajouter</button>
        </div>
        <div v-if="isCreationFormDisplayed" class="creation-form-wrapper">
            <h4>Nouveau contact</h4>
            <resource-form :schema="creationForm.schema"
                        :model="creationForm.model"
                        :triggers="creationForm.triggers"
                        @submit="handleHotlineContactCreation">
                <button slot="cancel"
                        class="btn btn-danger btn-sm"
                        @click.prevent="isCreationFormDisplayed = false">
                    Annuler
                </button>
            </resource-form>
        </div>
        <table v-if="hotlineContacts.length" class="table table-condensed">
            <thead>
                <tr>
                    <th>Nom</th>
                    <th>Téléphone</th>
                    <th>E-mail</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <hotline-contact-item v-for="hotlineContact in hotlineContacts"
                    :key="'hotline-contact-' + hotlineContact.id"
                    :hotline-contact="hotlineContact"
                    :actions-disabled="isFormDisplayed"
                    :contract-id="contract.id"
                    :contract-option-id="simpleHotlineContractOption.id"
                    :contract="contract"
                    @edition-form-status-updated="updateEditionFormDisplayStatus">
                </hotline-contact-item>
                <!-- <tr v-for="hotlineContact in hotlineContacts"
                    :key="'hotline-contact-' + hotlineContact.id">
                    <td>{{ hotlineContact.name }}</td>
                    <td>{{ hotlineContact.phone }}</td>
                    <td>{{ hotlineContact.email }}</td>
                    <td align="middle">
                        <button class="btn btn-sm" :class="{disabled: isFormDisplayed}">Modifier</button>
                        <button class="btn btn-sm"
                                :class="{disabled: isFormDisplayed}"
                                @click="removeHotlineContact(hotlineContact)">Supprimer</button>
                    </td>
                </tr> -->
            </tbody>
        </table>
        <div v-else>Aucun contact n'a encore été ajouté</div>
    </div>
    <div v-else>N/A</div>
</template>

<script type="text/babel">
    import { mapState, mapActions, mapGetters } from 'vuex'
    import ResourceForm from "components/Forms/ResourceForm"
    import HotlineContactItem from "./HotlineContacts/HotlineContactItem"

    export default {
        name:"HotlineContacts",

        components: {
            ResourceForm,
            HotlineContactItem
        },

        data () {
            return {
                isCreationFormDisplayed: false,
                isEditionFormDisplayed: false,
                creationForm: {
                    schema: {},
                    model: {},
                    triggers: {},
                }
            }
        },

        computed: {
            ...mapGetters('contract', [
                'simpleHotlineContractOption'
            ]),

            ...mapState('contract', {
                contract: 'model',
                hotlineContacts: 'hotlineContacts'
            }),

            isFormDisplayed() {
                return this.isCreationFormDisplayed || this.isEditionFormDisplayed
            }
        },

        methods: {
            ...mapActions('contract', [
                'fetchHotlineContacts',
                'addHotlineContact'
            ]),

            getHotlineContactCreationForm() {
                this.axios.get(`contracts/${this.contract.id}/options/${this.simpleHotlineContractOption.id}/hotline_contacts/create`)
                    .then(response => {
                        let { form } = response.data
                        this.creationForm = _.assign({}, form)
                        this.isCreationFormDisplayed = true
                    })
            },

            handleHotlineContactCreation({ data: model }) {
                this.addHotlineContact(model)
                    .then(() => this.isCreationFormDisplayed = false)
            },

            updateEditionFormDisplayStatus(value) {
                this.isEditionFormDisplayed = value
            }
        },

        created() {
            this.fetchHotlineContacts()
        }
    }
</script>

<style lang="scss" scoped>
    .creation-form-wrapper {
        box-shadow: 0 1px 10px rgba(0,0,0,0.15);
        padding: 5px 15px 15px;
        background-color: #fafafa;
    }
</style>



// WEBPACK FOOTER //
// client/components/Customer/ContractManagementContent/HotlineContacts.vue